export const kohSamuiHotels = {
  'centara-reserve':
    'https://www.booking.com/hotel/th/centara-reserve-samui.he.html',
  'amari-samui': 'https://www.booking.com/hotel/th/amari-koh-samui.he.html',
  'chaweng-regent':
    'https://www.booking.com/hotel/th/chaweng-regent-beach-resort.he.html',
  'holiday-inn-bophut':
    'https://www.booking.com/hotel/th/holiday-inn-resort-samui-bophut-beach.he.html',
  'bandara-resort':
    'https://www.booking.com/hotel/th/bandara-resort-spa.he.html',
  'melia-samui': 'https://www.booking.com/hotel/th/melia-koh-samui.he.html',
  'kimpton-kitalay':
    'https://www.booking.com/hotel/th/kimpton-kitalay-samui.he.html',
  silavadee:
    'https://www.booking.com/hotel/th/silavadee-pool-spa-resort.he.html',
  'outrigger-samui':
    'https://www.booking.com/hotel/th/outrigger-koh-samui-beach-resort.he.html',
  'pavilion-samui':
    'https://www.booking.com/hotel/th/pavilion-samui-villas-resort.he.html',
};
